class BuildYourOwnBundle extends HTMLElement {
  constructor() {
    super();

    this.state = {
      steps: {},      // { stepHandle: [{variantId, title, price, productId, productTitle}] }
      prices: 0       // total in cents
    }
    this.limit = Number(this.dataset.byobLimit)
    this.discount = Number(this.dataset.byobDiscount)
    this.byobId = this.dataset.byobId

    this.productCards = this.querySelectorAll('[data-byob-select]')
    this.cardSelectButtons = this.querySelectorAll('[data-byob-hidden-select]')

    this.summaryRows = this.querySelectorAll('[data-byob-summary-row]')
    this.totalPriceEl = this.querySelector('[data-byob-total-price]')
    this.originalPriceEl = this.querySelector('[data-byob-original-price]')
    this.addBtn = this.querySelector('[data-byob-add-to-cart]')

    this.summaryOverlay = this.querySelector('[data-byob-summary-overlay]')
    this.summaryClose = this.querySelector('[data-byob-summary-close]')
  }

  connectedCallback() {
    this.restoreByobStateFromLocalStorage() // Restore state on page load
    this.initAtc()
    this.initCards()
    this.initSummaryClose()
  }

  /**
   * Restore BYOB state from localStorage
   */
  restoreByobStateFromLocalStorage () {
    try {
      const savedState = localStorage.getItem('byob_cart_state');
      if (!savedState) return;

      const parsedState = JSON.parse(savedState);
      if (!parsedState.steps || Object.keys(parsedState.steps).length === 0) return;

      // Restore state
      this.state.steps = parsedState.steps;
      this.state.prices = parsedState.prices || 0;
      this.state.originalPrice = parsedState.originalPrice || 0;


      // Wait for product cards to be rendered, then select them
      const attemptRestore = () => {
        let allFound = true;

        Object.entries(this.state.steps).forEach(([stepHandle, products]) => {
          if (!products || products.length === 0) return;

          const productData = products[0]; // Each step has one product
          const variantId = productData.variantId;
          const productId = productData.productId;
          const productHandle = productData.productHandle;

          // Find the step element
          const stepElement = this.querySelector(`[data-step="${stepHandle}"]`);
          if (!stepElement) {
            allFound = false;
            return;
          }

          // Find product cards in this step by product ID or handle
          const productCards = stepElement.querySelectorAll('product-card');
          let foundCard = null;

          productCards.forEach(function (card) {
            const cardProductId = card.dataset.productId;
            const cardProductHandle = card.dataset.productHandle;

            // Match by product ID or handle
            if (cardProductId === productId || cardProductHandle === productHandle) {
              foundCard = card;

              // Try to find and select the matching variant
              const swatches = card.querySelectorAll('input[type="radio"][data-variant-id]');
              let variantFound = false;

              swatches.forEach(function (swatch) {
                if (swatch.dataset.variantId === variantId && !swatch.classList.contains('is-disabled')) {
                  swatch.checked = true;
                  swatch.dispatchEvent(new Event('change', { bubbles: true }));
                  variantFound = true;
                }
              });

              // If no swatch found, try to update the hidden variant ID element
              if (!variantFound) {
                const variantIdElement = card.querySelector('[id^="oneVarId--"]');
                if (variantIdElement) {
                  variantIdElement.dataset.variantId = variantId;
                }
              }

              // Add selected class to product card
              card.classList.add('selected');
            }
          });

          if (!foundCard) {
            allFound = false;
          }
        });

        // Update the summary UI
        this.updateSummary();

        // If not all cards found, try again after a short delay
        if (!allFound) {
          setTimeout(attemptRestore, 500);
        } else {
          console.log('BYOB state restored from localStorage:', this.state);
        }
      }

      // Start restoration attempts
      setTimeout(attemptRestore, 500);
    } catch (error) {
      console.error('Error restoring BYOB state from localStorage:', error);
    }
  }

  /**
   * Save BYOB state to localStorage
   */
  saveByobStateToLocalStorage () {
    try {
      if (Object.keys(this.state.steps).length > 0) {
        localStorage.setItem('byob_cart_state', JSON.stringify(this.state));
      } else {
        localStorage.removeItem('byob_cart_state');
      }
    } catch (error) {
      console.error('Error saving BYOB state to localStorage:', error);
    }
  }

  /**
   * Update info in the Summary
   */
  updateSummary () {
    console.log({
      state: this.state
    })

    this.summaryRows.forEach(row => {
      const title = row.querySelector('.byob-summary__title')
      const price = row.querySelector('.byob-summary__price')

      if (this.state.steps[title.dataset.step]) {
        row?.classList.add('selected')
        const product = this.state.steps[title.dataset.step][0]
        let displayTitle = product.title

        // Add variant options if they exist
        if (!!product.variantOptions) {
          displayTitle += `<div class="byob-summary__variant">${product.variantOptions.join(', ')}</div>`
        }

        title.innerHTML = displayTitle
        price.textContent = this.money(product.price)
      }
    })

    this.totalPriceEl.textContent = this.money(this.state.prices)
    this.originalPriceEl.textContent = this.money(this.state.originalPrice)
    this.addBtn.disabled = Object.keys(this.state.steps).length >= this.limit ? false : true
  }

  /**
   * Add all to cart with simple animation
   */
  initAtc () {
    if (!this.addBtn) { return }
    this.addBtn.addEventListener('click', async () => {
      const bundleId = `BYOB-${this.byobId}-${Date.now().toString(36)}`
      const items = []

      Object.entries(this.state.steps).forEach(([step, arr]) => {
        arr.forEach(sel => {
          items.push({
            id: sel.variantId,
            quantity: 1,
            properties: {
              _byob: 'true',
              _bundleId: bundleId,
              _bundleStep: step
            }
          })
        })
      })

      // Show loading state
      this.addBtn.disabled = true
      this.addBtn.textContent = 'Adding to Cart...'

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        })

        const result = await response.json()

        // Show success state
        this.addBtn.textContent = 'Added to Cart!'
        this.addBtn.style.backgroundColor = '#28a745'

        // Reset button after delay
        setTimeout(() => {
          this.addBtn.disabled = true
          this.addBtn.textContent = 'Bundle Added to Cart'
          this.addBtn.style.backgroundColor = ''
        }, 2000)

        document.dispatchEvent(new CustomEvent('cart:refresh'))
        const cartTrigger = document.querySelector('[aria-controls="cart-drawer"]')
        cartTrigger && cartTrigger.click()

        this.summaryOverlay.hidden = true
        this.summaryClose.hidden = true
        document.querySelector('safe-sticky').classList.remove('lock')

      } catch (error) {
        console.error('Error adding bundle to cart:', error)
        this.addBtn.disabled = false
        this.addBtn.textContent = 'Add Bundle to Cart'
        this.addBtn.style.backgroundColor = ''
      }
    })
  }

  initSummaryClose () {
    this.summaryClose.addEventListener('click', () => {
      this.summaryOverlay.hidden = false
      this.summaryClose.hidden = false
      document.querySelector('safe-sticky').classList.add('lock')
    })
  }

  initCards () {
    document.addEventListener('click', (e) => {
      this.cardSelect(e)
    })

    this.cardSelectButtons.forEach(cardSelectButton => {
      cardSelectButton.addEventListener('click', (e) => {
        this.cardSelect(e)
      })
    });
  }

  cardSelect (e) {
    let byobElement = e.target.closest('[data-byob-select]')
    if (!byobElement) return

    const productCard = e.target.closest('product-card')

    // Check if the product has available variants - prevent selection if sold out
    if (productCard && productCard.dataset.hasAvailableVariants === 'false') {
      e.preventDefault()
      e.stopPropagation()
      return false // Don't allow selection of sold out products
    }

    // Check if the clicked element is a disabled oos swatch/variant
    if (e.target.classList.contains('is-disabled') || e.target.closest('.is-disabled')) {
      e.preventDefault()
      return false // Don't allow selection of disabled variants
    }

    byobElement.classList.add('selected')

    if (e.target.closest('.product-card')?.classList.contains('selected')) {
      byobElement = e.target.closest('.product-card').querySelector('[data-byob-select]')
    }

    if (productCard) {
      const productId = productCard.dataset.productId
      let selectedSwatch = productCard.querySelector('.product-card__swatch-list input[type="radio"]:checked')
      if (e.target.name && e.target.name.startsWith('swatch-template--')) selectedSwatch = e.target

      // Double-check that the selected swatch is not disabled
      if (selectedSwatch && selectedSwatch.classList.contains('is-disabled')) {
        return // Don't proceed if the swatch is disabled
      }

      const variantId = selectedSwatch ? (selectedSwatch.dataset.variantId || selectedSwatch.value) : productCard.querySelector('[id^="oneVarId--"]').dataset.variantId

      // Get the step handle from the parent byob-step
      const stepElement = productCard.closest('[data-step]')
      const stepHandle = stepElement ? stepElement.dataset.step : null

      if (stepHandle && variantId) {
        // Get product details
        const productTitle = productCard.querySelector('.product-card__title')?.textContent?.trim() || 'Unknown Product'

        // Get price from the sale-price element (most reliable)
        const priceInCents = Number(productCard.dataset.price)

        // Get variant option values
        let variantOptions = []
        if (selectedSwatch) {
          const optionValue = selectedSwatch.dataset.variantName || ''
          if (optionValue) variantOptions.push(optionValue)
        }

        // Create product object
        const productData = {
          variantId: variantId,
          productId: productId,
          productHandle: productCard.dataset.productHandle,
          title: productTitle,
          price: priceInCents,
          variantOptions: variantOptions
        }

        // Each step can only have one product - always replace the entire array
        this.state.steps[stepHandle] = [productData]

        // Remove selected class from all product cards in this step
        const stepElement = productCard.closest('[data-step]')
        const allCardsInStep = stepElement.querySelectorAll('product-card')
        allCardsInStep.forEach(card => card?.classList.remove('selected'))

        // Add selected class to the clicked product card
        productCard?.classList.add('selected')

        let originalPrice = 0
        let totalPrice = 0

        for (let step in this.state.steps) {
          const product = this.state.steps[step][0]
          originalPrice = originalPrice + product.price
          totalPrice = totalPrice + (product.price - (product.price / this.discount))
        }
        this.state.originalPrice = originalPrice
        this.state.prices = totalPrice
        this.updateSummary()

        // Save to localStorage to keep it in sync
        this.saveByobStateToLocalStorage()
      }
    }
  }

  money (cents) {
    return (Shopify && Shopify.formatMoney ? Shopify.formatMoney(cents) : `$${(cents / 100).toFixed(2)}`)
  }
}

customElements.define('build-your-own-bundle', BuildYourOwnBundle);